import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const AllCategories = loadable(() => pMinDelay(import('./AllCategories'), 300), {
  fallback: <Loading />
});

const AsyncAllCategories = props => {
  const pageConfig = {
    headerType: 'full',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    loadGameListFull: false,
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent?.device?.type } bg-solid-white`
      },
      title: 'Bilyoner.com | Kategoriler'
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <AllCategories { ...props } helmet={ pageConfig.helmet } />
    </ApplicationLayout>
  );
};

AsyncAllCategories.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncAllCategories;
